
  document.addEventListener('DOMContentLoaded', function () {
    

    // console.log(thumbsEl);
    // 所有 thumbnail slides
    const thumbSlides = thumbsEl.querySelectorAll('.splide__slide');

    thumbSlides.forEach((thumbSlide, index) => {
      thumbSlide.addEventListener('click', function () {

         if (window.isThumbClickLocked) return;
          window.isThumbClickLocked = true;
          const mediaId = thumbSlide.dataset.mediaId;

          // ⭐ 直接根据 data-media-id 找主图对应 slide
          const targetSlide = thumbsEl.querySelector(`[data-media-id="${mediaId}"]`);
          const maintargetSlide = mainEl.querySelector(`[data-media-id="${mediaId}"]`);
          if (!targetSlide) return;

          // ⭐ 从主图 slide 的 index 属性取真实 index
          const targetIndex = Number(targetSlide.getAttribute('index'));
          const maintargetIndex = Number(maintargetSlide.getAttribute('index'));

          setTimeout(() => {

              mainEl.splide.go(maintargetIndex); 
              // 缩略图跳转（保持同步）
              thumbsEl.splide.go(index);
              window.isThumbClickLocked = false;

          }, 100); 
         
      });

    });

  });

  function getSelectedVariantOptions() {
    const optionEls = document.querySelectorAll(".product-variant__value-desc");
    const options = [];

    optionEls.forEach(el => {
      const value = el.textContent.trim();
      if (value) options.push(value);
    });

    return options;
  }


  function findVariantByOptions(options) {
    // options 是一个数组，例如 ['Red', 'M'] 或 ['Black']
    return variant_json.find(v => {
      // 遍历用户传入的每一个选项
      return options.every((option, index) => {
        // 对应的 Shopify 属性名是 option1, option2, option3
        // index 0 对应 option1, index 1 对应 option2, 等等
        const optionKey = `option${index + 1}`;
        
        // 只要有一个选项不匹配，就返回 false
        return v[optionKey] === option;
      });
    });
  }

  // function getCurrentVariantPrice() {
  //   const options = getSelectedVariantOptions();
  //   const variant = findVariantByOptions(options);
  //   console.log(variant);
  //   if (!variant) return 0;
  //   return variant.price / 100; // Shopify 价格是分
  // }

  function getCurrentVariantPrice() {
      const options = getSelectedVariantOptions();
      const variant = findVariantByOptions(options);
      // console.log(options);
      // console.log("当前变体对象:", variant);


      // 获取价格状态的 DOM 元素
      const priceStatusEl = document.querySelector(".product-price__status");
      
      // 💡 新增逻辑：如果变体不存在，或者变体不可售 (available 为 false)
      if (!variant || !variant.available) {
          if (priceStatusEl) {
              priceStatusEl.classList.add("product-soldout");
          }
      } else {
          // 如果变体存在且有库存，确保移除该样式类
          if (priceStatusEl) {
              priceStatusEl.classList.remove("product-soldout");
          }
      }

      if (!variant) {
          return {
              price: 0,
              compare_price: 0,
              on_sale: false
          };
      }

      // Shopify 原始数据是分 (Cents)，这里转换为金额
      const price = variant.price / 100;
      const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
      const currencySymbol = '€';
      return {
          price: price,
          compare_price: comparePrice,
          // 如果原价大于现价，说明正在打折
          on_sale: comparePrice > price,
          symbol: currencySymbol
      };
  }

  function updateAllPriceDisplays() {
    const data = getCurrentVariantPrice();
    if (!data) return;

    // 格式化数字，保留两位小数并处理欧洲常用的逗号分隔符（如果需要）
    const formatPrice = (num) => {
      return num.toFixed(2).replace('.', ',') + ' ' + data.symbol;
    };

    // 找到页面上所有的价格容器
    const priceContainers = document.querySelectorAll('.product-price__main-amount');

    priceContainers.forEach(container => {
      let html = `<span class="main-price">${formatPrice(data.price)}</span>`;

      // 如果有原价，且原价大于现价，则加上原价显示
      if (data.compare_at_price && data.compare_at_price > data.price) {
        // 你可以自定义原价的 class 名，比如 compare-price
        html += `<span class="compare-price" style="text-decoration: line-through; opacity: 0.6; margin-left: 8px;">
                  ${formatPrice(data.compare_at_price)}
                </span>`;
      }

      container.innerHTML = html;
    });
  }

  function getAddonsTotal() {
    let total = 0;

    document.querySelectorAll(".addons-card").forEach(card => {
      const checkbox = card.querySelector(".addons-checkbox__input");
      if (!checkbox || !checkbox.checked) return;

      const priceEl = card.querySelector(".addons-card__price");
      const qtyEl   = card.querySelector(".qty-input");

      // 从 DOM 获取价格（单位：分）
      let priceCents = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9]/g, "")) : 0;

      const qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;

      // ⭐ 先乘数量，再 /100
      total += (priceCents * qty) / 100;
    });

    return total;
  }
   
  function calculateTotalPrice() {
      const mainPrice = getCurrentVariantPrice().price;   // 欧元
      updateAllPriceDisplays();
      const addonsPrice = getAddonsTotal();         // 欧元
      const total = mainPrice + addonsPrice;

      /* -----------------------------
      * 1. 更新产品总价（原有逻辑）
      * ----------------------------- */
      const totalEl = document.querySelector(".product-total-price");
      if (totalEl) {
        totalEl.textContent = "€" + total.toFixed(2).replace('.', ',');
      }

      /* -----------------------------
      * 2. 更新 Order Summary 区域
      * ----------------------------- */
      const summaryFinal = document.querySelector(".order-summary__total-final");
      if (summaryFinal) {
        summaryFinal.textContent = total.toFixed(2).replace('.', ',') + " €";
      }

      /* -----------------------------
      * 3. 如果你未来需要显示旧价格（划线价）
      *    这里预留接口
      * ----------------------------- */
      const summaryOld = document.querySelector(".order-summary__total-old");
      if (summaryOld) {
        // 如果你有旧价格逻辑，可以在这里设置
        // summaryOld.textContent = "799,99 €";
        summaryOld.textContent = ""; // 默认清空
      }

      return total;
    }



  // 更新按钮状态
  function updateThumbArrows(swiper) {
    const prev = document.querySelector('.pdp-thumb-arrow--left');
    const next = document.querySelector('.pdp-thumb-arrow--right');

    // 先全部激活
    prev.classList.add('active');
    next.classList.add('active');

    // 到头部 → 禁用左箭头
    if (swiper.isBeginning) {
      prev.classList.remove('active');
    }

    // 到尾部 → 禁用右箭头
    if (swiper.isEnd) {
      next.classList.remove('active');
    }
  }

  function parsePresetVariantGroups(presetEl) {
    const raw = presetEl.dataset.addons_product_index;
    if (!raw) return [];

    return raw.split(",").map(group => {
      return group.split("--").map(id => id.trim());
    });
  }

   
  function applyPresetToAddonGroups(groups) {
    const addonGroups = document.querySelectorAll(".addons-entry-list-item");

    groups.forEach((variantIdList, groupIndex) => {
      const groupEl = addonGroups[groupIndex];
      if (!groupEl) return;

      // 清空该组所有 checkbox & qty
      groupEl.querySelectorAll(".addons-checkbox__input").forEach(cb => cb.checked = false);
      groupEl.querySelectorAll(".qty-input").forEach(q => q.value = 0);

      // 遍历该组的 variantId
      variantIdList.forEach(variantId => {
        const btn = groupEl.querySelector(`button[data-curvariantid="${variantId}"]`);
        if (!btn) return;

        // 模拟点击 swatch
        btn.click();

        const card = btn.closest(".addons-card");
        if (!card) return;

        // 勾选 checkbox
        const checkbox = card.querySelector(".addons-checkbox__input");
        if (checkbox) checkbox.checked = true;

        // 数量至少为 1
        const qtyInput = card.querySelector(".qty-input");
        if (qtyInput && parseInt(qtyInput.value, 10) === 0) {
          qtyInput.value = 1;
        }
      });
    });
  }

  // 封装判断逻辑
  function handleMobileScrollLock(isLock) {
      // 只有在屏幕宽度小于 768px 时才处理
      if (window.innerWidth >= 768) return;

      const $html = $("html");
      const $stickyHeader = $("#sticky-header");

      if (isLock) {
          $html.addClass('lock-scroll');
          $stickyHeader.addClass('sticky-unset');
      } else {
          // 延迟移除，等待动画结束
          setTimeout(function() {
              // 确保没有其他抽屉还开着
              if ($("[open]").length === 0) {
                  $html.removeClass('lock-scroll');
                  $stickyHeader.removeClass('sticky-unset');
              }
          }, 600);
      }
  }

  // ================= 新增：独立的库存检测函数 =================
  // ================= 全新升级：全规格交叉库存联动检测函数 =================
  function checkColorDrawerStock() {
    const productVariants = variant_json; 
    if (!productVariants || productVariants.length === 0) return;

    const colorDrawer = document.querySelector(".color-drawer");
    if (!colorDrawer) return;

    // 1. 获取主页面上，目前被选中的所有规格值（排除当前颜色弹窗自己对应的那个规格项）
    // 假设你的主页面每个规格项容器有统一的类，比如 .product-variant__item-container
    // 我们通过里面的 .product-variant__value-title 获取用户当前选了什么（比如 "M码", "木质"）
    const activeOtherOptions = [];
    
    // 找到当前颜色弹窗的 optionId，用来在主页面排除它自己
    const colorDrawerId = colorDrawer.id || "";
    const colorOptionId = colorDrawerId.replace('variant-length-drawer-', '');

    document.querySelectorAll(".product-variant__item-container").forEach(item => {
      // 如果是颜色自己的容器，跳过不统计
      if (item.id === `product-variant__item-container-${colorOptionId}`) return;
      
      const valueEl = item.querySelector(".product-variant__value-title");
      if (valueEl) {
        const val = valueEl.textContent.trim().toLowerCase();
        if (val) activeOtherOptions.push(val); // 收集其他选中的属性，如 ["large", "oak"]
      }
    });

    console.log("activeOtherOptions",activeOtherOptions);
    return;

    // 2. 获取颜色弹窗下的所有颜色选项
    const colorOptions = colorDrawer.querySelectorAll(".product-variant__drawer-option-container");

    // 3. 遍历颜色选项，结合“其他已选属性”去 Shopify JSON 中核对总库存状态
    colorOptions.forEach(container => {
      const descEl = container.querySelector(".product-variant__option-desc");
      if (!descEl) return;
      
      // 当前颜色名字，转为小写以便精准匹配（如 "nussbaum-schwarz"）
      // 如果后台是 "Nussbaum / Schwarz"，这里可以把连字符换成斜杠兼容，或者直接用独立单规格名
      const currentColorName = descEl.textContent.trim().toLowerCase();

      // 4. 去 Shopify 变体库里找：【包含当前颜色】且【包含其他所有已选属性】的那个具体变体
      const matchedVariant = productVariants.find(variant => {
        // Shopify 的 variant.options 是一个数组，例如 ["Large", "Oak", "Nussbaum / Schwarz"]
        const variantOptionsLower = variant.options.map(opt => opt.toLowerCase());

        // 检查该变体是否包含当前颜色 (支持处理连字符和斜杠差异)
        const hasCurrentColor = variantOptionsLower.some(opt => 
          opt === currentColorName || opt.replace(/\s*\/\s*/g, '-') === currentColorName
        );

        if (!hasCurrentColor) return false;

        // 检查该变体是否同时满足外面选中的其他所有 Option
        // 例如外面选了 "Large"，那该变体必须也包含 "large"
        const matchOthers = activeOtherOptions.every(otherOpt => 
          variantOptionsLower.includes(otherOpt)
        );

        return matchOthers;
      });

      // 5. 根据匹配到的最终变体状态，控制显示或隐藏
      // 如果找不到对应的变体组合，或者找到了但 available 为 false (无库存)
      if (!matchedVariant || !matchedVariant.available) {
        container.classList.add("sold-out");
        container.classList.remove("selected"); // 如果刚好被隐藏了，顺便移除选中态
      } else {
        container.classList.remove("sold-out"); // 库存恢复了，移出隐藏类
      }
    });
  }

  // ================= 2. 全新：基于 Shopify 属性的动态库存核对 =================
  function checkColorDrawerStockByShopifyOptions() {
    if (!window.variant_json || !window.productOptionsNames) return;

    const colorDrawer = document.querySelector(".color-drawer");
    if (!colorDrawer) return;
    

    // 第一步：找出“颜色”在 Shopify option 里的索引位置 (0, 1 或 2)
    // 比如后台顺序是 Size, Color。那么 names 是 ["Size", "Color"]，颜色的 index 就是 1 (对应 option2)
    const colorOptionIndex = window.productOptionsNames.findIndex(name => 
      name.toLowerCase() === 'color' || name.toLowerCase() === 'farbe' // 兼容德语/英语后台
    );
  
    if (colorOptionIndex === -1) return; // 如果找不到颜色规格，直接退出

    // 第二步：收集当前页面上【所有规格】当前选中的文本值（按 option1, option2 顺序排列）
    var currentSelectedOptions = [];
  

    currentSelectedOptions = getSelectedVariantOptions();

    // console.log("currentSelectedOptions",currentSelectedOptions);

    // return;

    // 第三步：遍历颜色 Drawer 内部的每一个颜色选项，动态换流检测
    const colorOptions = colorDrawer.querySelectorAll(".product-variant__drawer-option-container");
    // console.log("colorOptions", colorOptions);
    colorOptions.forEach(container => {
      const descEl = container.querySelector(".product-variant__option-desc");
      if (!descEl) return;
      
      const thisColorName = descEl.textContent.trim(); // 当前这个图片节点的颜色名字，如 "Nussbaum-Schwarz"

      // 💡 核心魔法：克隆一份当前所有选中的属性数组
      const testOptions = [...currentSelectedOptions];
      
      // 把“当前选中的颜色”临时替换成“正在遍历的这个颜色”
      // 比如原本选了 ['M', 'Wood', 'Red']，现在变成 ['M', 'Wood', 'Nussbaum-Schwarz']
      testOptions[colorOptionIndex] = thisColorName;

      // 丢进你的函数里，寻找对应的变体
      const targetVariant = findVariantByOptions(testOptions);

      // 第四步：根据找到的变体库存状态，决定显示或隐藏
      // 1. 如果这个颜色跟其他属性组合出来的变体压根不存在
      // 2. 或者找到了，但是 available 为 false (无库存)
      // console.log(targetVariant);
      if (!targetVariant || !targetVariant.available) {
        // SKU 不存在或已售罄：直接隐藏
        container.style.display = "none";
        container.classList.remove("selected");
      } else {
        // SKU 存在且可购买：恢复显示
        container.style.removeProperty("display");
        container.classList.remove("sold-out");
      }
    });
  }


  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.pdp-thumb-slide');
    if (!thumb) return;

    const mediaId = thumb.getAttribute('data-media-id');
    if (!mediaId) return;

    // 触发主图切换
    const target = document.querySelector(`.product__thumbnail-item-${mediaId}`);
    if (target) {
        target.click();
    }

    // 移除所有 active
    document.querySelectorAll('.pdp-thumb-slide.active').forEach(el => {
        el.classList.remove('active');
    });

    // 给当前点击的加 active
    thumb.classList.add('active');
  });

 (function () {
  /**
   * 1. 弹窗打开函数
   * 增加：根据传入的 isShorts 参数切换 class
   */
  function openModal(modal, isShorts) {
    const dialog = modal.querySelector(".modal-dialog");
    
    // 清除旧类名，确保样式不冲突
    if (dialog) {
      dialog.classList.remove("modal-video", "modal-video-shorts");
      
      // 根据视频类型添加你定义的 class
      if (isShorts) {
        dialog.classList.add("modal-video-shorts");
      } else {
        dialog.classList.add("modal-video");
      }
    }

    modal.classList.add("show");
    modal.style.display = "block";
    document.body.classList.add("modal-open");

    // 创建遮罩
    let backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop show";
    backdrop.dataset.modalBackdrop = modal.id;
    document.body.appendChild(backdrop);
  }

  /**
   * 2. 弹窗关闭函数 (保持原有逻辑)
   */
  function closeModal(modal) {
    modal.classList.remove("show");
    modal.style.display = "none";
    document.body.classList.remove("modal-open");

    // 移除遮罩
    const backdrop = document.querySelector(`[data-modal-backdrop="${modal.id}"]`);
    if (backdrop) backdrop.remove();

    // 彻底停止视频播放
    const iframe = modal.querySelector("iframe");
    if (iframe) {
      iframe.src = ""; 
    }
  }

  /**
   * 3. 核心点击监听
   */
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[data-modal-target]");
    if (!trigger) return;

    e.preventDefault();
    
    const modalId = trigger.dataset.modalTarget;
    const modal = document.getElementById(modalId);
    const youtubeUrl = trigger.getAttribute('data-href') || trigger.href; 

    if (modal && youtubeUrl) {
      // 判断是否为 Shorts 链接 (支持 URL 包含 shorts 关键字)
      const isShorts = youtubeUrl.includes('/shorts/') || youtubeUrl.includes('shorts');
      
      // 提取 ID
      const videoId = extractYouTubeId(youtubeUrl);
      
      if (videoId) {
        const iframe = modal.querySelector('iframe');
        if (iframe) {
          // 构造 embed 地址
          const newSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1`;
          iframe.src = newSrc;
        }
      }
      
      // 调用增强后的打开函数，传入判断结果
      openModal(modal, isShorts);
    }
  });

  /**
   * 4. 辅助函数：提取 ID (兼容常规和 Shorts)
   */
  function extractYouTubeId(url) {
    // 增强正则：兼容 shorts 路径提取
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)|(\/shorts\/))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    
    // YouTube ID 长度固定为 11 位
    if (match) {
        // 这里的索引根据正则变化可能有所不同，通常取最后捕获的一组
        const id = match[match.length - 1];
        return (id && id.length == 11) ? id : false;
    }
    return false;
  }


  
  /**
   * 5. 关闭按钮事件监听
   */
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest("[data-modal-close]");
    if (!closeBtn) return;

    const modal = closeBtn.closest(".modal");
    if (modal) closeModal(modal);
  });

  /**
   * 6. 点击外部区域关闭
   */
  document.addEventListener("click", function (e) {
    const modal = document.querySelector(".modal.show");
    if (!modal) return;

    const backdrop = document.querySelector(`[data-modal-backdrop="${modal.id}"]`);
    
    // 如果点击的是遮罩层本身，或者点击的是 modal 容器（且不在 dialog 内部）
    if (e.target === backdrop || e.target === modal) { 
      closeModal(modal);
    } 
  });

  /**
   * 7. ESC 按键关闭
   */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      const modal = document.querySelector(".modal.show");
      if (modal) closeModal(modal);
    }
  });
  })();

  document.addEventListener("DOMContentLoaded", function() {

    document.addEventListener('click', function(e) {
      const toggle = e.target.closest('.addons-presets__toggle');
      if (!toggle) return;

      // 切换 active
      toggle.classList.toggle('active');

      // 控制显示隐藏
      const list = document.getElementById('addons-presets-list');
      if (list) {
        list.classList.toggle('hidden');
      }
    });

  });

    document.addEventListener("DOMContentLoaded", function() {
      const optionContainers = document.querySelectorAll(".product-variant__drawer-option-container");
      var stickyHeader = document.getElementById("sticky-header");
      // 点击 option container，只做选中状态切换
      optionContainers.forEach(container => {
        container.addEventListener("click", function() {
          const siblings = container.parentNode.querySelectorAll(".product-variant__drawer-option-container");
          siblings.forEach(sib => sib.classList.remove("selected"));
          container.classList.add("selected");
        });
      });

      
      // ================= 核心：核对并处理无库存逻辑 =================
      if (variant_json && variant_json.length > 0) {
        // 1. 过滤出所有没有库存的变体
        const soldOutVariants = variant_json.filter(variant => !variant.available);
        console.log("sold out", soldOutVariants);
      }

      
      // 点击 footer，才执行更新和触发
      const footers = document.querySelectorAll(".product-variant__drawer-footer");
      footers.forEach(footer => {
        footer.addEventListener("click", function() {
          const drawer = footer.closest(".product-variant__drawer");
          if (!drawer) return;

          
          // 找到当前选中的 option container
          const selectedContainer = drawer.querySelector(".product-variant__drawer-option-container.selected");
          if (!selectedContainer) return;

          // 获取标题和描述
          const titleEl = selectedContainer.querySelector(".product-variant__option-title");
          const descEl  = selectedContainer.querySelector(".product-variant__option-desc");
          const newTitle = titleEl ? titleEl.textContent.trim() : "";
          const newDesc  = descEl ? descEl.textContent.trim() : "";

          // 更新到上方显示区域
           // 1. 获取当前 drawer 的完整 ID (例如: "variant-length-drawer-123456")
          const drawerId = drawer.id;

          // 2. 提取出 option_id 部分
          // 方案 A: 如果你的 ID 格式固定是 "variant-length-drawer-" 开头
          const optionId = drawerId.replace('variant-length-drawer-', '');

          // 方案 B: 更通用的做法，取最后一个横杠之后的内容
          // const optionId = drawerId.split('-').pop();

          // 3. 拼接出 parentContainer 的 ID 并获取元素
          const parentContainerId = `product-variant__item-container-${optionId}`;
          const parentContainer = document.getElementById(parentContainerId);

          // console.log("定位到的 Parent ID:", parentContainerId);
          // console.log("元素对象:", parentContainer);

          
          // 4. 执行更新逻辑
          if (parentContainer) {
            const valueTitleEl = parentContainer.querySelector(".product-variant__value-title");
            const valueDescEl  = parentContainer.querySelector(".product-variant__value-desc");
            
            if (valueTitleEl) valueTitleEl.textContent = newTitle;
            if (valueDescEl)  valueDescEl.textContent = newDesc;
            if (current_product_handle == "esslinger-pc-halterung" && newDesc == "Schwarz"){
               $(".product-variant__value-desc-container span.schwarz-presale").show();
            }else{
              $(".product-variant__value-desc-container span.schwarz-presale").hide();
            }
            console.log(current_product_handle);
          }

            // 触发对应 label 的点击
            const labelId = selectedContainer.getAttribute("data-labelid");
            if (labelId) {
              const targetLabel = document.querySelector(`label[for='${labelId}']`);
              if (targetLabel) {
                targetLabel.click();
              }
            }

            updateVariantSummaryDisplay();
                      // 关闭 drawer
            drawer.removeAttribute("open");
            // 或者用 class 控制： drawer.classList.remove("open");

            // ⭐ 新增：计算总价（基于 variant_json + Addons） 
            calculateTotalPrice();
            handleMobileScrollLock(false);

            checkColorDrawerStockByShopifyOptions();
            
        });   
     });


    // document.addEventListener("click", function (e) {
    //     const btn = e.target.closest(".addons-swatches__item");
    //     if (!btn) return;

    //     // 当前 block-swatch
    //     const block = btn.closest(".block-swatch");
    //     if (!block) return;

    //     // 当前 swatch 组
    //     const list = block.closest(".block-swatch-list");

    //     // 当前 addons-swatches-container（用于更新 option-value）
    //     const container = block.closest(".addons-swatches-container");

    //     // 1. 清除同组 active + checked
    //     list.querySelectorAll(".addons-swatches__item").forEach(item => {
    //         item.classList.remove("addons-swatches__item--active");
    //     });
    //     list.querySelectorAll(".block-swatch__radio").forEach(input => {
    //         input.checked = false;
    //     });

    //     // 2. 当前按钮加 active
    //     btn.classList.add("addons-swatches__item--active");

    //     // 3. 当前 input checked
    //     const input = block.querySelector(".block-swatch__radio");
    //     if (input) input.checked = true;

    //     // 4. 更新当前 addons-swatches-container 下的 option-value 文本
    //     if (container && input) {
    //         const valueTargetId = input.dataset.bindValue; // 如 addons-option-product-new-xxx-value
    //         const valueTarget = container.querySelector(`#${valueTargetId}`);
    //         if (valueTarget) {
    //             valueTarget.textContent = input.value;
    //         }
    //     }
    // });


    $(document).on("click", ".addons-swatches__item", function (e) {
        const $btn = $(this);
        
        // 当前 block-swatch
        const $block = $btn.closest(".block-swatch");
        if (!$block.length) return;

        // 当前 swatch 组 (直接在父级列表内找同类元素，比原生 querySelectorAll 效率更高)
        const $list = $block.closest(".block-swatch-list");
        
        // 当前 addons-swatches-container
        const $container = $block.closest(".addons-swatches-container");

        // 1. 清除同组 active 并给当前按钮加 active
        $list.find(".addons-swatches__item").removeClass("addons-swatches__item--active");
        $btn.addClass("addons-swatches__item--active");

        // 2. 清除同组 radio 的 checked，并勾选当前 block 下的 radio
        $list.find(".block-swatch__radio").prop("checked", false);
        const $input = $block.find(".block-swatch__radio");
        if ($input.length) {
            $input.prop("checked", true);
        }

       const currentVariantId = $btn.data("curvariantid");

       console.log($btn);
       console.log(currentVariantId);
        // 1. 获取父级 article
        const $article = $btn.closest(".addons-card");

        // 2. 找到 article 下的 checkbox 并改变其 value
        if ($article.length && currentVariantId) {
            const $checkbox = $article.find(".addons-checkbox__input");
            
            // 更新 checkbox 的 value 为当前选择的 variant ID
            $checkbox.val(currentVariantId);
            
            // 调试日志（可选）
            console.log("已更新 SKU " + $article.data("sku") + " 的变体 ID 为: " + currentVariantId);
        }


        // 3. 更新当前 container 下的 option-value 文本
        if ($container.length && $input.length) {
            const valueTargetId = $input.data("bindValue"); // jQuery .data() 会自动映射 data-bind-value
            if (valueTargetId) {
                const $valueTarget = $container.find("#" + valueTargetId);
                if ($valueTarget.length) {
                    $valueTarget.text($input.val());
                }
            }
        }
    });

    document.addEventListener("click", function (e) {
      const minusBtn = e.target.closest(".qty-btn--minus");
      const plusBtn = e.target.closest(".qty-btn--plus");

      if (!minusBtn && !plusBtn) return;

      const container = e.target.closest(".addon-qty");
      const input = container.querySelector(".qty-input");
      const card = container.closest(".addons-card");
      const checkbox = card.querySelector(".addons-checkbox__input");

      let value = parseInt(input.value, 10);

      if (plusBtn) {
        value++;
      } else if (minusBtn && value > 0) {
        value--;
      }

      input.value = value;

      // 控制 minus 按钮禁用状态
      const minus = container.querySelector(".qty-btn--minus");
      minus.disabled = value === 0;

      // ⭐ 当数量变成 0 → 自动取消 checkbox + 移除 active
      if (value === 0) {
        checkbox.checked = false;
        card.classList.remove("active");
      } else {
        // ⭐ 当数量 > 0 → 自动勾选 checkbox + 添加 active
        checkbox.checked = true;
        card.classList.add("active");
      }
    });


    document.addEventListener("change", function (e) {
        const checkbox = e.target.closest(".addons-checkbox__input");
        if (!checkbox) return;

        const card = checkbox.closest(".addons-card");
        if (!card) return;

        const qtyInput = card.querySelector(".qty-input");
        const minusBtn = card.querySelector(".qty-btn--minus");

        if (checkbox.checked) {
            card.classList.add("active");

            // 如果当前数量为 0，则自动设为 1
            if (qtyInput) {
                let value = parseInt(qtyInput.value, 10) || 0;
                if (value === 0) {
                    qtyInput.value = 1;
                    if (minusBtn) minusBtn.disabled = false;
                }
            }
        } else {
            card.classList.remove("active");

            // 取消勾选时数量归零，并禁用 minus
            if (qtyInput) {
                qtyInput.value = 0;
                if (minusBtn) minusBtn.disabled = true;
            }
        }
    });


    document.addEventListener("click", function(e) {
        const footer = e.target.closest(".addons-drawer__footer");
        var stickyHeader = document.getElementById("sticky-header");
        if (!footer) return;
        


        const drawer = footer.closest(".addons-drawer");
        const key = drawer.id.replace("addons-drawer-", "");

        // 收集当前 drawer 内选中的 addons
        const addons = collectSelectedAddons(drawer);

        console.log(addons);
        // 渲染入口区域
        renderAddonsEntrySelected(key, addons);

        // 渲染订单 summary 区域
        renderOrderSummarySection(key, addons);

        /* -----------------------------------------
        *  清除所有套件 Preset 的选中状态
        * ----------------------------------------- */
        document.querySelectorAll(".addons-presets__item").forEach(preset => {
            preset.classList.remove("selected");
        });

        // 关闭 drawer
        drawer.removeAttribute("open");

        // 更新总价
        calculateTotalPrice();
        handleMobileScrollLock(false)
    });



  $(document).ready(function() {
    const $stickyHeader = $("#sticky-header");


      // --- 1. 点击 Item 打开对应的 Drawer ---
    $(document).on("click", ".product-variant__item", function() {
        const $item = $(this);

        // 获取 data-optionid 属性值
        const optionId = $item.data("optionid");
        if (!optionId) {
          console.warn("未找到 data-optionid 属性");
          return;
        }

        // 拼接 ID：variant-length-drawer-xxxx
        const targetId = "#variant-length-drawer-" + optionId;
        const $drawer = $(targetId);

        if ($drawer.length) {
          // 开启前先关闭其他已打开的 drawer（可选，根据业务需求）
          $(".product-variant__drawer[open]").removeAttr("open");

          // 给目标 Drawer 增加 open 属性
          $drawer.attr("open", "true");

          // 锁定背景滚动
          handleMobileScrollLock(true)
        } else {
          console.error("未找到 ID 为 " + targetId + " 的 Drawer 盒子");
        }
      });

      // --- 2. 点击关闭按钮（及遮罩层）关闭 Drawer ---
      // 这里假设你的关闭按钮类名是 .product-variant__drawer-close
      $(document).on("click", ".product-variant__drawer-close, .drawer__overlay", function() {
        const $drawer = $(this).closest(".product-variant__drawer");
        
        if ($drawer.length) {
          $drawer.removeAttr("open");

          // 配合你的 CSS 动画时长（例如 0.6s）后移除锁定状态
          setTimeout(function() {
            if (!$(".product-variant__drawer[open]").length) {
              handleMobileScrollLock(false)
            }
          }, 600);
        }
      });

      /* ==========================================================================
      1. Presets 預設方案選擇邏輯
      ========================================================================== */
      $(document).on('click', '.addons-presets__item', function() {
        const $item = $(this);

        // --- 1. Preset UI 選中狀態切換 ---
        const isSelected = $item.hasClass('selected');
        $('.addons-presets__item').removeClass('selected');
        if (!isSelected) $item.addClass('selected');

        // --- 2. 解析二維 variantId 組 ---
        const raw = $item.data('addons_product_index'); // jQuery 內置處理 data- 屬性
        if (!raw) return;

        const groups = raw.split(",").map(group => {
          return group.split("--").map(id => id.trim());
        });

        // --- 3. 清空所有 Addons 狀態 ---
        $(".addons-checkbox__input").prop('checked', false);
        $(".qty-input").val(0);
        $(".addons-card").removeClass("active");

        // --- 4. 按組索引應用到對應 Addons 組 ---
        const $addonGroups = $(".addons-drawer");

        $.each(groups, function(groupIndex, variantIdList) {
          const $groupEl = $addonGroups.eq(groupIndex);
          if (!$groupEl.length) return;

          $.each(variantIdList, function(_, variantId) {
            const $btn = $groupEl.find(`button[data-curvariantid="${variantId}"]`);
            if (!$btn.length) return;

            // 模擬點擊 swatch
            $btn.trigger('click');

            const $card = $btn.closest(".addons-card");
            if (!$card.length) return;

            // 勾選 checkbox 並設置數量
            $card.find(".addons-checkbox__input").prop('checked', true);
            const $qtyInput = $card.find(".qty-input");
            if (parseInt($qtyInput.val(), 10) === 0) {
              $qtyInput.val(1);
            }

            // 激活卡片
            $card.addClass("active");
          });
        });

        // --- 5. 自動執行渲染與關閉 ---
        $addonGroups.each(function() {
          const $drawer = $(this);
          const key = $drawer.attr('id').replace("addons-drawer-", "");

          // 假設這些全局函數已經定義
          const addons = collectSelectedAddons($drawer[0]); // 如果函數需要原生 DOM，傳入 [0]
          console.log(addons);
          renderAddonsEntrySelected(key, addons);
          renderOrderSummarySection(key, addons);

          // 關閉 Drawer
          $drawer.removeAttr("open");
        });

        // --- 6. 更新總價 ---
        if (typeof calculateTotalPrice === "function") {
          calculateTotalPrice();
        }
      });

      $(document).on("touchend click", ".addons-drawer__footer", function(e) {
          
          // 在 jQuery 事件處理函數中，$(this) 指向當前的 .addons-drawer__footer
          const $footer = $(this);
          const $stickyHeader = $("#sticky-header");

          // 找到對應的 drawer 元素
          const $drawer = $footer.closest(".addons-drawer");
          
          // 獲取 ID 並提取 key
          const drawerId = $drawer.attr("id") || "";
          const key = drawerId.replace("addons-drawer-", "");

          // 執行業務邏輯
          const addons = collectSelectedAddons($drawer[0]); 
          renderAddonsEntrySelected(key, addons);
          renderOrderSummarySection(key, addons);

          // 清除 Preset 選中狀態
          $(".addons-presets__item").removeClass("selected");

          // 關閉 drawer
          $drawer.removeAttr("open");

        // 更新總價
          console.log(calculateTotalPrice());

          // 🚩 恢復背景滾動與 Header 狀態
          handleMobileScrollLock(false)
      });

      // --- 1. 打開 Drawer ---
      $(document).on("click", ".addons-entry", function(e) {
          // 如果點擊的是 Clear 按鈕，則不觸發打開 Drawer
          if ($(e.target).closest(".addons-entry__clear").length) return;

          const $entry = $(this);
          const addonKey = $entry.data("addons"); // 獲取 unter-deinem-schreibtisch
          const $targetDrawer = $("#addons-drawer-" + addonKey);

          // 關閉所有其他已打開的 drawer
          $(".addons-drawer[open]").removeAttr("open");

          // 打開目標 drawer
          if ($targetDrawer.length) {
              $targetDrawer.attr("open", "true");

              // 鎖定頁面滾動 & 處理 Header
              handleMobileScrollLock(true)
          }
      });

      // --- 2. 關閉 Drawer (點擊關閉按鈕、遮罩層、或確認 Footer) ---
      $(document).on("click", ".addons-drawer__close, .drawer__overlay, .addons-drawer__footer", function() {
          const $drawer = $(this).closest(".addons-drawer");
          
          if ($drawer.length) {
              $drawer.removeAttr("open");

              // 恢復頁面滾動 & 恢復 Header
            handleMobileScrollLock(false)
          }
      });
    });

    document.addEventListener("click", function (e) {
        const clearBtn = e.target.closest(".addons-entry__clear");
        if (!clearBtn) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const entry = clearBtn.closest(".addons-entry");
        const addonsKey = entry.dataset.addons;
        const drawer = document.querySelector(`#addons-drawer-${addonsKey}`);
        if (!drawer) return;

        /* -----------------------------
        * 1. 恢复入口 UI
        * ----------------------------- */
        const valueBox = entry.querySelector(".addons-entry__value");
        entry.classList.remove("selected");
        valueBox.classList.remove("addons-entry__value--selected");
        valueBox.innerHTML = `<div class="addons-entry__value-text">Select Products</div>`;

        /* -----------------------------
        * 2. 清空 drawer 内所有选中状态
        * ----------------------------- */
        drawer.querySelectorAll(".addons-card").forEach(card => {
            const checkbox = card.querySelector(".addons-checkbox__input");
            const qtyInput = card.querySelector(".qty-input");
            const minusBtn = card.querySelector(".qty-btn--minus");

            if (checkbox) checkbox.checked = false;
            if (qtyInput) qtyInput.value = 0;
            if (minusBtn) minusBtn.disabled = true;

            card.classList.remove("active");
        });

        /* -----------------------------
        * 3. 删除对应的 Order Summary 区块
        * ----------------------------- */
        const orderContainer = document.querySelector(".order-addons-main-container");
        const orderSection = orderContainer.querySelector(
            `.order-summary__section[data-addons="${addonsKey}"]`
        );
        if (orderSection) orderSection.remove();

        /* -----------------------------
        * 4. 清除所有 Preset（套件）的激活状态
        * ----------------------------- */
        document.querySelectorAll(".addons-presets__item").forEach(preset => {
            preset.classList.remove("selected");
        });
        /* -----------------------------
        * 5. 重新计算总价
        * ----------------------------- */
        calculateTotalPrice();
    });

    checkColorDrawerStockByShopifyOptions();

  });

  function collectSelectedAddons(drawer) {
    const selected = [];

    
    drawer.querySelectorAll(".addons-card").forEach(card => {
        const checkbox = card.querySelector(".addons-checkbox__input");
        
        if (!checkbox || !checkbox.checked) return;
        // console.log(checkbox);
        const activeSwatchBtn = card.querySelector(".addons-swatches__item.addons-swatches__item--active");
        const productId = activeSwatchBtn ? activeSwatchBtn.dataset.curvariantid : null;

        const title = card.querySelector(".addons-card__title")?.textContent.trim() || "";
        const price = card.querySelector(".addons-card__price")?.textContent.trim() || "";
        const image = card.querySelector(".addons-swatches__item.addons-swatches__item--active img")?.src || "";

        const variantValueEl = card.querySelector(".product-form__option-value");
        const variantName = variantValueEl ? variantValueEl.textContent.trim() : "";

        const qtyInput = card.querySelector(".qty-input");
        const qty = qtyInput ? parseInt(qtyInput.value, 10) : 0;

        selected.push({
            product_id: productId,
            title,
            variant: variantName,
            image,
            price,
            qty
        });
    });

    return selected;
  }

  function renderAddonsEntrySelected(key, addons) {
      const entry = document.querySelector(`.addons-entry[data-addons="${key}"]`);
      if (!entry) return;

      const valueBox = entry.querySelector(".addons-entry__value");
      valueBox.innerHTML = "";

      if (addons.length === 0) {
          entry.classList.remove("selected");
          valueBox.classList.remove("addons-entry__value--selected");
          valueBox.innerHTML = `<div class="addons-entry__value-text">Select Products</div>`;
          return;
      }

      entry.classList.add("selected");
      valueBox.classList.add("addons-entry__value--selected");

      addons.forEach(item => {
          const html = `
              <div class="addons-entry__selected-item">
                  <div class="addons-entry__selected-thumb">
                      <img src="${item.image}" alt="${item.title}">
                  </div>
                  <div class="addons-entry__selected-info">
                      <div class="addons-entry__selected-title">${item.title}</div>
                      <div class="addons-entry__selected-variant">${item.variant}</div>
                  </div>
                  <div class="addons-entry__selected-qty">x${item.qty}</div>
              </div>
          `;
          valueBox.insertAdjacentHTML("beforeend", html);
      });
  }

  function renderOrderSummarySection(groupKey, addons) {
    const container = document.querySelector(".order-addons-main-container");
    if (!container) return;

    // 先删除旧的同组模块（避免重复）
    const oldSection = container.querySelector(`.order-summary__section[data-addons="${groupKey}"]`);
    if (oldSection) oldSection.remove();

    // 如果没有选中产品，不渲染
    if (addons.length === 0) return;

    // 找到组名（来自 entry label）
    const entry = document.querySelector(`.addons-entry[data-addons="${groupKey}"]`);
    const groupLabel = entry?.querySelector(".addons-entry__label")?.textContent.trim()
                      || entry?.querySelector(".addons-entry__title")?.textContent.trim()
                      || "Add-ons";

    // 创建 section
    const section = document.createElement("div");
    section.className = "order-summary__section order-addons-summary__section";
    section.dataset.addons = groupKey;

    // 组标题
    section.insertAdjacentHTML("beforeend", `
      <div class="order-summary__label">${groupLabel}</div>
    `);

    // 遍历每个选中产品
    addons.forEach(item => {
      section.insertAdjacentHTML("beforeend", `
        <div class="order-summary__row">
          <div class="order-summary__details">
            <div class="order-summary__text-bold">
              ${item.title}${item.variant ? " - " + item.variant : ""}
            </div>
          </div>
          <div class="order-summary__qty">x${item.qty}</div>
          <div class="order-summary__price">${item.price}</div>
        </div>
      `);
    });

    // 分隔线
    section.insertAdjacentHTML("beforeend", `
      <hr class="order-summary__divider" />
    `);

    // 插入到容器末尾
    container.appendChild(section);
  }

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".video-toggle");
    if (!toggle) return;

    const section = toggle.closest(".video-section");
    section.classList.toggle("active");
  });

  /**
     * 辅助函数：获取所有已选 Option 并更新到价格区域
     */
  function updatePriceVariantDisplay() {
      // 1. 获取当前所有选中的变体值 (S, Red, 140x80cm 等)
      const currentOptions = getSelectedVariantOptions(); // 调用你已有的函数
      
      // 2. 找到价格区域的容器
      const priceVariantContainer = document.querySelector(".product-price__variant");
      if (!priceVariantContainer) return;

      // 3. 清空旧的内容，重新根据当前选项生成 HTML
      priceVariantContainer.innerHTML = ""; 

      currentOptions.forEach(val => {
          if (val) {
              const itemHtml = `<div class="product-price__variant-type">${val}</div>`;
              priceVariantContainer.insertAdjacentHTML("beforeend", itemHtml);
          }
      });
  }

  function updateVariantSummaryDisplay() {
        // 1. 获取当前所有选中的变体值 (例如: ["140x80cm", "2-Stufiges Gestell", "Nussbaum-Schwarz"])
        const currentOptions = getSelectedVariantOptions();
        
        // --- 区域 A: 更新价格下方的显示 ---
        const priceVariantContainer = document.querySelector(".product-price__variant");
        if (priceVariantContainer) {
            priceVariantContainer.innerHTML = ""; 
            currentOptions.forEach(val => {
                if (val) {
                    priceVariantContainer.insertAdjacentHTML("beforeend", 
                        `<div class="product-price__variant-type">${val}</div>`);
                }
            });
        }

        // --- 区域 B: 更新订单摘要 (Order Summary) 的详情 ---
        const orderSummaryDetails = document.querySelector(".order-summary__mainsection .order-summary__details");
        if (orderSummaryDetails) {
            orderSummaryDetails.innerHTML = ""; // 清空旧的变体行
            currentOptions.forEach(val => {
                if (val) {
                    // 这里渲染你要求的 order-summary__text-bold 结构
                    orderSummaryDetails.insertAdjacentHTML("beforeend", 
                        `<div class="order-summary__text-bold">${val}</div>`);
                }
            });
        }
    }



$(document).ready(function() {
    $('.pdp-reviews').on('click', function(e) {
        e.preventDefault(); // 阻止默认跳转
        
        var targetId = "#judgeme_product_reviews"; // 获取 href="#reviews"
        var $target = $(targetId); // 获取目标元素
        
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 600); // 600ms 滚动动画
        }
    });
});
